var map = {
	"./African.png": 305,
	"./All.png": 306,
	"./Bakers.png": 307,
	"./Bread.png": 308,
	"./Chinese .png": 309,
	"./Cookie.png": 310,
	"./Drinks.png": 311,
	"./Japanese.png": 312,
	"./Mexican.png": 313,
	"./Near Me.png": 314,
	"./Pastry.png": 315,
	"./Price.png": 316,
	"./Rice and Egg.png": 317,
	"./Thai.png": 318,
	"./carrot.svg": 319,
	"./chef.png": 320,
	"./chef_b.png": 321,
	"./cloche.png": 322,
	"./cooking.png": 323,
	"./curry.png": 324,
	"./immediate.png": 325,
	"./indian.png": 326,
	"./italian .png": 327,
	"./now.svg": 328,
	"./price.svg": 329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 330;